// Related events slider — arrow navigation for the horizontal scroll-snap list
// on the single-event template (mobile only). Mirrors the news carousel:
// scroll position is the source of truth, so arrows stay in sync with swipe/
// trackpad, advancing one card per click and disabling at each end.

document.addEventListener('alpine:init', () => {
  Alpine.data('eventRelatedSlider', () => ({
    atStart: true,
    atEnd: false,

    init() {
      this.$nextTick(() => this.update());

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.update();
          ticking = false;
        });
      };
      this.scroller?.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => this.update());
    },

    get scroller() {
      return this.$refs.track;
    },

    update() {
      const el = this.scroller;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      this.atStart = el.scrollLeft <= 1;
      this.atEnd = max <= 1 || el.scrollLeft >= max - 1;
    },

    step(direction) {
      const el = this.scroller;
      if (!el) return;
      const card = el.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      // Snap to an absolute card index so rapid clicks mid-animation don't compound.
      const index = Math.round(el.scrollLeft / stride);
      el.scrollTo({ left: (index + direction) * stride, behavior: 'smooth' });
    },
  }));
});
